import { z } from 'zod';
import { calendarDateSchema } from '@/features/listing-filters/calendarDate';

export const RUN_STATUSES = [
  'Pending',
  'Active',
  'Suspended',
  'Completed',
  'Suppressed',
  'Killed',
  'Errored',
] as const;

/**
 * Filters only, no pagination: a saved page number would drop you into the
 * middle of a list you last read days ago.
 *
 * Malformed values fall back to undefined via `.catch()` rather than throwing,
 * so a hand-edited URL degrades to an unfiltered list instead of a blank page.
 */
export const workflowRunsFiltersSchema = z.object({
  workflowId: z.array(z.string().min(1)).optional().catch(undefined),
  // Capped at 255 to match listRunsSchema: a longer hand-edited URL would be
  // accepted here and then rejected by the api.
  workflowName: z.string().min(1).max(255).optional().catch(undefined),
  workflowConfigurationId: z.array(z.string().min(1)).optional().catch(undefined),
  status: z.array(z.enum(RUN_STATUSES)).optional().catch(undefined),
  entityType: z.array(z.string().min(1)).optional().catch(undefined),
  triggeredBy: z.array(z.string().min(1)).optional().catch(undefined),
  createdFrom: calendarDateSchema.optional().catch(undefined),
  createdTo: calendarDateSchema.optional().catch(undefined),
});

export type WorkflowRunsFilterValues = z.infer<typeof workflowRunsFiltersSchema>;

export const workflowRunsSearchSchema = workflowRunsFiltersSchema.extend({
  page: z.number().int().min(1).optional().catch(undefined),
});
